export const formatFormValues = (values = {}) =>
  Object.keys(values).reduce((acc, key) => {
    const value = values[key];

    return {
      ...acc,
      [key]: typeof value === 'string' ? value.trim() : value,
    };
  }, {});
